<div class="chat-cp">
  <!-- âmbito: a minha loja (por omissão) ou toda a rede; o MASTER vê sempre a rede -->
  <div *ngIf="!master" class="chat-cp__scope" role="radiogroup" [attr.aria-label]="strings.colleagueScopeLabel">
    <button type="button" role="radio" class="chat-cp__scope-btn" [class.chat-cp__scope-btn--on]="scope === 'store'"
      [attr.aria-checked]="scope === 'store'" (click)="setScope('store')">{{ strings.colleagueScopeStore }}</button>
    <button type="button" role="radio" class="chat-cp__scope-btn" [class.chat-cp__scope-btn--on]="scope === 'network'"
      [attr.aria-checked]="scope === 'network'" (click)="setScope('network')">{{ strings.colleagueScopeNetwork }}</button>
  </div>

  <div class="chat-cp__filters">
    <label class="chat-cp__search form-control d-flex align-items-center gap-2 mb-0">
      <span class="visually-hidden">{{ strings.colleagueSearch }}</span>
      <chat-icon name="search" [size]="15"></chat-icon>
      <input type="search" class="chat-cp__input flex-grow-1 border-0 bg-transparent" autocomplete="off" [placeholder]="strings.colleagueSearch"
        (input)="onSearch($event)">
    </label>
    <ng-select *ngIf="scope === 'network' && stores.length > 1" class="chat-cp__store" [items]="stores" bindLabel="name" bindValue="id" [clearable]="true"
      [searchable]="true" appendTo="body" [placeholder]="strings.colleagueStoreAll" [ngModel]="storeId" (ngModelChange)="storeIdChange.emit($event)"></ng-select>
  </div>

  <div class="chat-cp__list">
    <p *ngIf="loading && visible.length === 0" class="text-muted px-3 py-2 mb-0" role="status">{{ strings.loading }}</p>
    <p *ngIf="!loading && visible.length === 0" class="text-muted px-3 py-3 mb-0">{{ strings.colleagueEmpty }}</p>
    <button *ngFor="let u of visible; trackBy: trackByUser" type="button" class="chat-cp__row" [class.chat-cp__row--on]="selectedId === u.userAppId"
      [attr.aria-pressed]="selectedId === u.userAppId" (click)="pick(u)">
      <chat-avatar [src]="photo(u)" [name]="u.name" [size]="36"></chat-avatar>
      <span class="chat-cp__text">
        <span class="chat-cp__name">{{ u.name }}</span>
        <span class="chat-cp__sub">{{ subtitle(u) }}</span>
      </span>
      <chat-icon *ngIf="selectedId === u.userAppId" name="check" [size]="16" class="chat-cp__check"></chat-icon>
    </button>
  </div>
</div>
